import React from 'react';
import { Box, CircularProgress, Typography, useTheme } from '@mui/material';

interface LoadingScreenProps {
  message?: string;
  fullScreen?: boolean;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({
  message = 'Loading...',
  fullScreen = false,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: fullScreen ? '100vh' : '100%',
        width: '100%',
        position: fullScreen ? 'fixed' : 'relative',
        top: 0,
        left: 0,
        backgroundColor: fullScreen
          ? `${theme.palette.background.paper}CC` // Semi-transparent background
          : 'transparent',
        zIndex: fullScreen ? theme.zIndex.modal : 1,
        p: 3,
        minHeight: fullScreen ? 'auto' : '200px',
      }}
    >
      <CircularProgress
        size={fullScreen ? 60 : 40}
        thickness={4}
        sx={{ mb: 2 }}
      />
      <Typography
        variant={fullScreen ? 'h6' : 'body1'}
        color="text.secondary"
        align="center"
      >
        {message}
      </Typography>
    </Box>
  );
};

export default LoadingScreen;
